import { type Country } from 'src/types/country';
import { type CurrencyType } from 'src/types/currency';

export const COUNTRY_BY_CURRENCY_MAP: Record<CurrencyType, Country> = {
  AED: 'UAE',
  SAR: 'KSA',
  KWD: 'KWT',
  BHD: 'BHR',
  QAR: 'QAT',
};
